type Business = {
  phoneNumber: string | null;
};

type Retailer = {
  Business: Business;
};

type Order = {
  retailerContactSmsNumber: string | null;
  Retailer: Retailer;
};

export const getContactNumber = (
  order: Order,
  connectionNumber: string | null | undefined,
): string | null => {
  return (
    order.retailerContactSmsNumber ??
    connectionNumber ??
    order.Retailer.Business.phoneNumber ??
    null
  );
};
